import { catchError, map, switchMap } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class CustomTranslateService implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) {}

  getTranslation(lang: string): Observable<any> {
    if (!this.authenticationService?.currentUserValue) {
      return this.http.get(`./assets/translate/core/${lang}.json`).pipe(
        switchMap((coreJson: any) =>
          this.http.get(`./assets/translate/shared/${lang}.json`).pipe(
            map((sharedJson: any) => {
              let combinedLabelJson = {
                ...coreJson,
                ...sharedJson,
              };
              return combinedLabelJson;
            })
          )
        ),
        catchError((error) => {
          console.error("couldn't fetch app labels: ");
          return throwError(error);
        })
      );
    }

    const params = new HttpParams().append('langCode', lang);
    return this.http
      .get('/core/labels', {
        params: params,
      })
      .pipe(
        switchMap((serverJson: any) =>
          this.http.get(`./assets/translate/core/${lang}.json`).pipe(
            switchMap((coreJson: any) =>
              this.http.get(`./assets/translate/shared/${lang}.json`).pipe(
                map((sharedJson: any) => {
                  let combinedLabelJson = {
                    ...coreJson,
                    ...sharedJson,
                    ...serverJson?.data,
                  };
                  return combinedLabelJson;
                })
              )
            )
          )
        ),
        catchError((error) => {
          console.error("Couldn't fetch core labels", error);
          return this.http.get(`./assets/translate/core/${lang}.json`).pipe(
            switchMap((coreJson: any) =>
              this.http.get(`./assets/translate/shared/${lang}.json`).pipe(
                map((sharedJson: any) => {
                  let combinedLabelJson = {
                    ...coreJson,
                    ...sharedJson,
                  };
                  return combinedLabelJson;
                })
              )
            ),
            catchError((error) => {
              console.error("couldn't fetch app labels: ");
              return throwError(error);
            })
          );
        })
      );
  }
}
